import { makeStyles } from '@mui/styles';

export const usePopupStyle = makeStyles(() => ({
  paper: {
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  popup: {
    zIndex: 1300,
  },
}));
